import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell, Check, Checks, ArrowSquareOut } from "@phosphor-icons/react";
import { api, formatDateTime } from "../lib/api";

export default function Notifications() {
  const [notifs, setNotifs] = useState([]);
  const load = () => api.get("/notifications").then((r) => setNotifs(r.data));
  useEffect(() => { load(); }, []);
  const unread = notifs.filter((n) => !n.read).length;

  const markRead = async () => { await api.post("/notifications/mark-read"); load(); };
  const markOneRead = async (id) => {
    setNotifs((list) => list.map((n) => (n.id === id ? { ...n, read: true } : n)));
    try { await api.post(`/notifications/${id}/read`); } catch { load(); }
  };

  return (
    <div className="space-y-4 stagger-in max-w-3xl mx-auto" data-testid="notifications-page">
      <div className="flex items-end justify-between gap-3">
        <div>
          <h1 className="text-2xl sm:text-3xl font-heading font-extrabold tracking-tight text-slate-900">Notifications</h1>
          <p className="text-sm text-slate-500 mt-0.5">{unread ? `${unread} unread` : "You are all caught up"}</p>
        </div>
        {unread > 0 && (
          <button type="button" data-testid="mark-all-read-button" onClick={markRead} aria-label="Mark all as read" title="Mark all as read"
            className="tap h-10 px-3 sm:px-4 rounded-xl border border-slate-200 bg-white text-sm font-semibold text-slate-700 flex items-center gap-1.5 hover:bg-slate-50">
            <Checks size={18} /><span className="hidden sm:inline">Mark all read</span>
          </button>
        )}
      </div>
      <div className="rounded-2xl bg-white border border-slate-200/80 shadow-[0_1px_3px_rgba(15,23,42,0.04)] divide-y divide-slate-100 overflow-hidden">
        {notifs.length === 0 && (
          <div className="p-12 text-center text-slate-500" data-testid="empty-notifications">
            <Bell size={34} weight="duotone" className="mx-auto mb-2 text-slate-300" /><p className="text-sm">No notifications yet</p>
          </div>
        )}
        {notifs.map((n) => (
          <div key={n.id} data-testid={`notification-${n.id}`} className={`flex gap-3 px-4 py-3.5 transition-colors ${!n.read ? "bg-brand-50/50" : ""}`}>
            <span className={`mt-0.5 w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${!n.read ? "bg-brand-500 text-white" : "bg-slate-100 text-slate-500"}`}><Bell size={17} weight={!n.read ? "fill" : "regular"} /></span>
            <div className="min-w-0 flex-1">
              <div className="font-semibold text-sm text-slate-900">{n.title}</div>
              <p className="text-sm text-slate-600 mt-0.5 leading-relaxed">{n.message}</p>
              <div className="text-[11px] text-slate-400 mt-1 font-mono">{formatDateTime(n.created_at)}</div>
            </div>
            <div className="flex flex-col gap-1 shrink-0">
              {!n.read && (
                <button type="button" data-testid={`mark-read-${n.id}`} onClick={() => markOneRead(n.id)} aria-label="Mark as read" title="Mark as read"
                  className="tap w-9 h-9 rounded-full text-brand-700 hover:bg-brand-100 flex items-center justify-center"><Check size={18} weight="bold" /></button>
              )}
              {n.customer_id && (
                <Link to={`/customers/${n.customer_id}`} aria-label="Open file" title="Open file" data-testid={`notification-open-${n.id}`}
                  className="tap w-9 h-9 rounded-full text-slate-500 hover:bg-slate-100 flex items-center justify-center"><ArrowSquareOut size={17} /></Link>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
